import Phaser from 'phaser';
import { getEventEmitter } from "../services/EventService";

export class GameOver extends Phaser.Scene {

    constructor() {
        super('game-over');
    }

    init(data) {
        this.playerScore = data.playerScore;
    }

    create() {

        const width = this.scale.width;
        const height = this.scale.height;

        this.add.text(width * 0.5, height * 0.5 - 160, '😵 Game Over!', { fontSize: 64, padding: 10 }).setOrigin(0.5);
        this.add.text(width * 0.5, height * 0.5 - 60, `You score: ${this.playerScore}`, { fontSize: 36 }).setOrigin(0.5);

        this.add.text(width * 0.5, height * 0.5 + 100, 'Try again', { fontSize: 36, color: "#177ddc" })
            .setInteractive({ cursor: 'pointer' })
            .setOrigin(0.5)
            .on("pointerdown", () => this.scene.start('game'));

        this.add.text(width * 0.5, height * 0.5 + 190, 'Submit to leaderboard', { fontSize: 36, color: "#177ddc" })
            .setInteractive({ cursor: 'pointer' })
            .setOrigin(0.5)
            .on("pointerdown", () => getEventEmitter().emit("savePlayerScore", this.playerScore));
    }

}